import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/test',
            name: 'Test',
            component: (resolve) => require(['@/views/exam/test'], resolve)
        },
        {
            path: '/tougao',
            name: 'Tougao',
            component: (resolve) => require(['@/views/tougao/index'], resolve)
        },

        {
            path: '/confirmTouGao',
            name: 'confirmTouGao',
            component: (resolve) => require(['@/views/tougao/confirmTouGao'], resolve)
        },

        {
            path: '/confirm_new',
            name: 'ConfirmNew',
            component: (resolve) => require(['@/views/tougao/confirm_new'], resolve)
        },

        {
            path: '/homeTougao',
            name: 'HomeTouGao',
            component: (resolve) => require(['@/views/homeTouGao/index'], resolve)
        },

        {
            path: '/my',
            name: 'My',
            component: (resolve) => require(['@/views/my/index'], resolve)
        },

        {
            path: '/message',
            name: 'Message',
            component: (resolve) => require(['@/views/message/index'], resolve)
        },

        {
            path: '/messageDetail',
            name: 'MessageDetail',
            component: (resolve) => require(['@/views/message/detail'], resolve)
        },

        {
            path: '/login',
            name: 'Login',
            component: (resolve) => require(['@/views/my/login'], resolve)
        },

        {
            path: '/homeExam', // 考试 - 首页
            name: 'HomeExam',
            component: (resolve) => require(['@/views/homeExam/index'], resolve)
        },

        {
            path: '/examArticleDetail', // 考试 - 文章详情
            name: 'ExamArticleDetail',
            component: (resolve) => require(['@/views/homeExam/detail'], resolve)
        },

        {
            path: '/signUp', // 考试 - 报名
            name: 'SignUp',
            component: (resolve) => require(['@/views/exam/signUp'], resolve)
        },

        {
            path: '/confirmExam', // 考试 - 查分
            name: 'ConfirmExam',
            component: (resolve) => require(['@/views/exam/confirmExam'], resolve)
        },

        {
            path: '/admissionTicket', // 考试 - 准考证
            name: 'AdmissionTicket',
            component: (resolve) => require(['@/views/exam/admissionTicket'], resolve)
        },

        {
            path: '/myExam', // 考试 - 我的
            name: 'MyExam',
            component: (resolve) => require(['@/views/exam/myExam'], resolve)
        },

        {
            path: '/searchScore', // 考试 - 查分
            name: 'SearchScore',
            component: (resolve) => require(['@/views/exam/searchScore'], resolve)
        },

        { path: '/', redirect: '/homeTougao' }
    ]
})

// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })

// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0)
// })

export default router
